import script from "./SignupSecnondStepForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupSecnondStepForm.vue?vue&type=script&setup=true&lang=js"

import "./SignupSecnondStepForm.vue?vue&type=style&index=0&id=b23f298e&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snedson-auth-backend/snedson-auth-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b23f298e"]])

export default __exports__